/**
 * 后端工厂：按 URL 参数选择演示后端或真实 P2P 后端。
 *
 * - `?demo=1`：本地 Mock 后端（离线演示/截图/UI 单测）
 * - 默认：P2PRoomBackend（WebRTC + 本地信令；见 src/state/p2pRoomBackend.ts）
 */
import { MockRoomBackend } from './mockBackend.ts';
import type { RoomBackend } from './types.ts';

type BackendKind = 'p2p' | 'mock';

export function resolveBackendKind(search: string = globalThis.location?.search ?? ''): BackendKind {
  const params = new URLSearchParams(search);
  if (params.get('demo') === '1' || params.get('backend') === 'mock') return 'mock';
  return 'p2p';
}

export async function createBackend(kind: BackendKind = resolveBackendKind()): Promise<RoomBackend> {
  if (kind === 'mock') return new MockRoomBackend();
  const { P2PRoomBackend } = await import('./p2pRoomBackend.ts');
  return new P2PRoomBackend();
}
